// Color mapping for categories
const categoryColors = [
  { bg: 'yst-bg-blue-200', text: 'yst-text-blue-900' },
  { bg: 'yst-bg-green-200', text: 'yst-text-green-900' },
  { bg: 'yst-bg-purple-200', text: 'yst-text-purple-900' },
  { bg: 'yst-bg-pink-200', text: 'yst-text-pink-900' },
  { bg: 'yst-bg-yellow-200', text: 'yst-text-yellow-900' },
  { bg: 'yst-bg-indigo-200', text: 'yst-text-indigo-900' },
  { bg: 'yst-bg-red-200', text: 'yst-text-red-900' },
  { bg: 'yst-bg-orange-200', text: 'yst-text-orange-900' },
  { bg: 'yst-bg-teal-200', text: 'yst-text-teal-900' },
  { bg: 'yst-bg-cyan-200', text: 'yst-text-cyan-900' },
  { bg: 'yst-bg-lime-200', text: 'yst-text-lime-900' },
  { bg: 'yst-bg-emerald-200', text: 'yst-text-emerald-900' },
  { bg: 'yst-bg-sky-200', text: 'yst-text-sky-900' },
  { bg: 'yst-bg-violet-200', text: 'yst-text-violet-900' },
  { bg: 'yst-bg-fuchsia-200', text: 'yst-text-fuchsia-900' },
  { bg: 'yst-bg-rose-200', text: 'yst-text-rose-900' },
  { bg: 'yst-bg-amber-200', text: 'yst-text-amber-900' },
];

/**
 * Simple hash function to map category names to colors
 * Ensures that the same category name always gets the same color
 * Special case: "Other" category always gets slate colors
 *
 * @param category - The category name to get colors for
 * @returns Object containing background and text color classes
 */
export const getCategoryColor = (category: string) => {
  if (!category) return categoryColors[0]; // Default to blue if no category

  // Special case: "Other" category always gets slate
  if (category.toLowerCase() === 'other') {
    return { bg: 'yst-bg-slate-200', text: 'yst-text-slate-900' };
  }

  let hash = 0;
  for (let i = 0; i < category.length; i++) {
    const char = category.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }

  const index = Math.abs(hash) % categoryColors.length;
  return categoryColors[index];
};

/**
 * Get just the background color class for a category
 *
 * @param category - The category name
 * @returns Background color class string
 */
export const getCategoryBackgroundColor = (category: string) => {
  return getCategoryColor(category).bg;
};

/**
 * Get just the text color class for a category
 *
 * @param category - The category name
 * @returns Text color class string
 */
export const getCategoryTextColor = (category: string) => {
  return getCategoryColor(category).text;
};
